require("jquery");
import "bootstrap-sass";
import "material-design-lite/src/mdlComponentHandler";
import "material-design-lite/src/textfield/textfield";
import "material-design-lite/src/slider/slider";
import "./vendor/assets/javascript/fastruby/custom.js";